const pagesIndividualEquipmentsEn = {
  headers: {
    assetTag: 'Asset tag',
    assignee: 'Assigned to',
    equipmentTypeName: 'Type',
    manufacturer: 'Manufacturer',
    modelNumber: 'Model number',
    name: 'Equipment',
    status: 'Status'
  },
  pageTitle: 'Equipment',
  status: {
    assigned: 'Assigned',
    available: 'Available',
    decommissioned: 'Decommissioned',
    placed: 'Placed at site',
    under_repair: 'Under repair'
  },
  tabs: {
    managedPlace: 'Equipment at sites I manage',
    self: 'My equipment'
  }
};
export default pagesIndividualEquipmentsEn;